<template>
    <p>this is a form to create / edit assessment activation statuses</p>
    <v-form 
        v-model="valid" 
        ref="form" 
        :disabled="props.disabled" 
        :readonly="resolvedReadonlyFields" 
        :loading="resolvedIsFetchingAssessmentActivationStatus"
        :style="props.standalone ? 'max-width: 960px; margin-inline: auto' : ''"
    >
        <v-row class="ma-0">
            <v-col class="px-0" cols="12">

                <v-radio-group 
                    v-model="formValues.type"
                    :label="`Tipo de Avaliação${resolvedReadonlyFields ? '' : '*'}`"
                    :rules="[
                        
                    ]"    
                    :readonly="resolvedReadonlyFields"
                    :disabled="props.disabled"
                >
                    <v-radio value="self" label="Auto-Avaliação"></v-radio>
                    <v-radio value="ascending" label="Avaliação Ascendente"></v-radio>
                    <v-radio value="downward" label="Avaliação Descendente"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col class="px-0" cols="12">
                <v-autocomplete 
                    v-model="formValues.year" 
                    :items="yearsList" 
                    :label="`Ano${resolvedReadonlyFields ? '' : '*'}`" 
                    autocomplete="off"
                    variant="outlined"
                    :rules="[]" 
                    :clearable="!resolvedReadonlyFields" 
                    :readonly="resolvedReadonlyFields" 
                    :menu-icon="resolvedReadonlyFields ? '' : undefined"
                    :disabled="props.disabled"
                    :loading="resolvedIsFetchingAssessmentActivationStatus"
                    
                />
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col class="px-0 d-flex flex-column align-start" cols="12">
                <p>Avaliação Ativa{{resolvedReadonlyFields ? '' : "*"}}</p>
                <v-switch 
                    v-model="formValues.enabled" 
                    :readonly="resolvedReadonlyFields"
                    :indeterminate="formValues.enabled === null"
                    :disabled="props.disabled"
                    :loading="resolvedIsFetchingAssessmentActivationStatus"
                >
                    <template #prepend>
                        <span class="cursor-pointer" @click="formValues.enabled = false">
                            Não
                        </span>
                    </template>
                    <template #append>
                        <span class="cursor-pointer" @click="formValues.enabled = true">Sim</span>
                    </template>
                </v-switch>
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col class="px-0" cols="12">
                <v-date-input
                    v-model="formValues.starts_on"
                    :label="`De${resolvedReadonlyFields ? '' : '*'}:`"
                    :clearable="!resolvedReadonlyFields"
                    :readonly="resolvedReadonlyFields"
                    :disabled="props.disabled || formValues.enabled === false"
                    :loading="resolvedIsFetchingAssessmentActivationStatus"
                    prepend-icon=""
                    variant="outlined"
                >

                </v-date-input>
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col class="px-0" cols="12">
                <v-date-input 
                    v-model="formValues.ends_on" 
                    :label="`Até${resolvedReadonlyFields ? '' : '*'}:`"
                    :clearable="!resolvedReadonlyFields"
                    :readonly="resolvedReadonlyFields"
                    :disabled="props.disabled || formValues.enabled === false"
                    :loading="resolvedIsFetchingAssessmentActivationStatus"
                    prepend-icon=""
                    variant="outlined"
                ></v-date-input>
            </v-col>
        </v-row>
    </v-form>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import actionReferences from '../../../composables/actionReferences';


const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    isFetchingActivationStatus : {
        type: Boolean,
        default: false,
    },
    action: {
        type: String,
        default: "create",
    },
    standalone: {
        type: Boolean,
        default: false,
    },

    minimumYear: {
        type: [String,Number],
        default: 2000,
    },

    yearOffset: {
        type: [String, Number],
        default: 1,
    },

});

defineExpose({
    validate,
    submit,
});

const currentYear = new Date().getFullYear()
const yearsList = 
    Array.from(
        Array(currentYear + Number(props.yearOffset)).keys()
    ).toReversed()
    .toSpliced(currentYear - Number(props.minimumYear) + Number(props.yearOffset) )
;

const valid = ref(null);
const form = ref("form");

const formValues = ref({
    type: null,
    year: null,
    enabled: null,
    starts_on: null,
    ends_on: null, 
});

const localIsFectchingActivationStatus = ref(false);

const localAction = ref(props.action);
const localIsSubmitting = ref(false);


const resolvedReadonlyFields = computed(() => {
    return props.readonly
            || actionReferences.isValidReadonlyAction(localAction.value)
})

const resolvedIsFetchingAssessmentActivationStatus = computed(() => {
    return props.isFetchingActivationStatus 
            || localIsFectchingActivationStatus.value;
});

async function validate() {

}

async function submit() {

}

onMounted(() => {

});
</script>